import { createSlice } from '@reduxjs/toolkit';
import FeatureService from '@/services/feature-service';

export const featuresSlice = createSlice({
  name: 'features',
  initialState: {
    items: [], // string[]
    loaded: false,
    derivedPlan: 'pro'
  },
  reducers: {
    setFeaturesToState: (state, action) => {
      const payload = action.payload;
      let items = [];
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        items = FeatureService.resolveActiveFeatures(payload);
      } else {
        const rawFeaturesArray = Array.isArray(payload) ? payload : [];
        items = FeatureService.resolveActiveFeatures({ features: rawFeaturesArray });
      }
      state.items = items;
      state.loaded = true;
      state.derivedPlan = FeatureService.derivePlan(new Set(items));
    },
    clearFeatures: (state) => {
      state.items = [];
      state.loaded = false;
      state.derivedPlan = 'pro';
    }
  }
});

export const { setFeaturesToState, clearFeatures } = featuresSlice.actions;

// Selector to return resolved features Set
export const selectFeatures = (state) => {
  return new Set(state.features?.items || []);
};

export const selectFeaturesLoaded = (state) => {
  return !!state.features?.loaded;
};

export const selectDerivedPlan = (state) => {
  return state.features?.derivedPlan || 'pro';
};

export default featuresSlice.reducer;
